// InviteLinkPage.jsx
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import defaultClubImage2 from '../../images/clubs/club-1.png'
import styles from './club.module.css';
import NavHeader from '../../shared/Nav-Header';


const InviteLinkPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [clubInfo, setClubInfo] = useState(null);
    const [error, setError] = useState(null);
    const [joining, setJoining] = useState(false);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        fetchClubInfo();
    }, [token]);

    const fetchClubInfo = async () => {
        try {
            const response = await axios.get(`/api/club/invite-info/${token}`);
            if (response.data.success) {
                setClubInfo(response.data.club);
                setShowModal(true);
                // console.log('Fetched club info:', response.data.club);
            }
        } catch (err) {
            // console.error('Error fetching club info:', err.message);
            setError(err.response?.data?.message || 'Failed to load club information');
        }
    };

    const handleJoinClub = async () => {
        setJoining(true);
        try {
            const response = await axios.post(`/api/club/join-via-invite`, 
                { token },
                { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
            );

            if (response.data.success) {
                navigate(`/club/${response.data.clubId}`);
            }
        } catch (err) {
            const errorMsg = err.response?.data?.message || 'Failed to join club';
            // console.error('Error joining club:', errorMsg);
            // If token expired or invalid, close modal
            if (err.response?.status === 410 || err.response?.status === 404) {
                setShowModal(false);
            }
        } finally {
            setJoining(false);
        }
    };

    const handleCancel = () => {
        setShowModal(false);
        navigate('/clubs');
    };

    const getTimeRemaining = () => {
        if (!clubInfo?.expiresAt) return '';
        const now = new Date();
        const expires = new Date(clubInfo.expiresAt);
        const diff = expires - now;
        
        if (diff < 0) return 'Expired';
        
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        
        if (days > 0) {
            return `Expires in ${days} day${days > 1 ? 's' : ''} ${hours}h`;
        }
        return `Expires in ${hours} hour${hours > 1 ? 's' : ''}`;
    };

    if (error) {
        return (
            <div  >
                <div  >
                    <h2 >Invalid Invite Link</h2>
                    <p >{error}</p>
                    <button onClick={() => navigate('/clubs')}>
                        Browse Clubs
                    </button>
                </div>
            </div>
        );
    }

    return (
        <>
        <NavHeader/>
            {showModal && clubInfo && (
                <div >
                    <img 
                        title={clubInfo.name} 
                        src={clubInfo.profilePicture ? clubInfo.profilePicture.replace('/upload/', '/upload/w_288,h_300,c_fill/') : defaultClubImage2}alt="pfp" 
                        className={styles.networkProfilePicture} 
                    />                    <h1 >{clubInfo.name}</h1>
                    <span >{clubInfo.memberCount} members</span>
                    <p >{getTimeRemaining()}</p>

                    <h3 >About this Club</h3>
                    <p>{clubInfo.description}</p>
                    <p> You've been invited to join this club!</p>
                    <p>Click "Join Club" to become a member and start participating.</p>
                    <button onClick={handleJoinClub}  disabled={joining} >
                        {joining ? 'Joining...' : 'Join Club'}
                    </button>
                    <button onClick={handleCancel} disabled={joining} >
                        Cancel
                    </button>
                </div>
            )}
        </>
    );
};

export default InviteLinkPage;